import View from "../framework/view";
import Server from "../server";
import {Map_} from "../google/apis";
import {west_row_botanica} from "./map";
import jQuery from "jquery";
import {renderDollars} from "../misc/utils";
import {autocomplete} from "../google/autocomplete";
import {DeliveryConfig} from "../bo/delivery_config";

export class DeliverySampleCostsMap extends View {

    static classname = "delivery-samples-costs-map-view";

    private samples: any;

    private readonly server = Server.instance();

    private cachedElt?: JQuery<HTMLElement>;

    private map: any = null;

    private markers: google.maps.Marker[] = [];

    constructor() {
        super(DeliverySampleCostsMap.classname);
    }

    refresh(config: DeliveryConfig) {
        if (! config) {
            return;
        }
        this.server.getSampleDeliveryCosts(config).then((samples) => {
            this.samples = samples;
            if (! this.map) {
                this.update();
            } else {
                console.log("Updating map");
                this.addMarkers(this.map);
            }
        });
    }

    protected render0(): JQuery<HTMLElement> {

        if (this.cachedElt) {
            return this.cachedElt;
        }

        const out = jQuery("<div></div>");

        if (this.samples) {
            this.cachedElt = out;
            this.afterUpdate(() => {
                this.renderMap();
            });
        }

        return out;
    }

    renderMap() {

        const elt = this.elt()[0];

        if (!elt) {
            return;
        }

        Map_.then((Map: any) => {

            const center = west_row_botanica;
            // @ts-ignore
            const map = new Map(elt, {
                center: west_row_botanica,
                zoom: 11,
            });

            this.map = map;

            const bounds = this.addMarkers(map  );
            map.fitBounds(bounds);

        }).catch((err: any) => {
            console.error("Map failed", err);
        });

    }

    addMarkers(map: any) {

        for (const marker of this.markers) {
            marker.setMap(null);
        }
        this.markers.length = 0;

        var bounds = new google.maps.LatLngBounds();
        for (const sample of this.samples) {

            const address = sample.address;
            const position = {lat: sample.lat, lng: sample.lng};

            const marker = new google.maps.Marker({
                position: position,
                map,
                title: `km=${sample.km} mins=${sample.minutes} address=${sample.address}`,
                label: {
                    text: renderDollars(sample.dollars), //  + " " + sample.address,
                    color: "black"
                },
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 0
                }
            });

            this.markers.push(marker);

            bounds.extend(position);
        }

        return bounds;
    }

}
